







































































































































































































































































































































































































































































import Vue from 'vue'
import moment from 'moment'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default Vue.extend({
	components: { VueCropper, vSelect },
	layout: 'registration',
	data() {
		return {
			step: 2,
			user: {
				title: '',
				firstName: '',
				lastName: '',
				email: '',
				gender: '',
				country: '',
				primaryLanguage: this.$i18n.locale ? this.$i18n.locale : 'de',
				password: '',
				passwordRepeat: '',
				dateOfBirth: {
					day: '',
					month: '',
					year: '',
					tooYoung: false,
				},
				website: '',
				linkedIn: '',
				xing: '',
				occupation: '',
				company: '',
				privacy: {
					publicProfile: true,
					publicEmail: false,
				},
			},
			salutation: 'Good Evening',
			isSaving: false,
			emailRegistered: false,
			steps: [
				{
					firstStep: 2,
					lastStep: 4,
					label: this.$t('onboarding.steps.personalDetails'),
				},
				{
					firstStep: 5,
					lastStep: 7,
					label: this.$t('onboarding.steps.credentials'),
				},
				{
					firstStep: 9,
					lastStep: 12,
					label: this.$t('onboarding.steps.profile'),
				},
				{
					firstStep: 13,
					lastStep: 13,
					label: this.$t('onboarding.steps.portfolio'),
				},
			],
			dragging: false,
			imageSelected: false,
			tmpImage: null as null,
			shares: [] as Array<any>,
			companySearchQuery: '',
			stockSearchResults: [] as Array<any>,
			availableCountries: [] as Array<any>,
			showToast: false,
			toastMessage: '',
			privacyAccepted: false,
			termsAccepted: false,
			availableUserTitles: [
				{
					name: this.$t('onboarding.userTitleNone'),
					value: '',
				},
				{
					name: 'Dr.',
					value: 'Dr.',
				},
				{
					name: 'Prof.',
					value: 'Prof.',
				},
				{
					name: 'Prof. Dr.',
					value: 'Prof. Dr.',
				},
			],
			availableGenders: [
				{
					name: this.$t('profile.genders.male'),
					value: 'male',
				},
				{
					name: this.$t('profile.genders.female'),
					value: 'female',
				},
				{
					name: this.$t('profile.genders.others'),
					value: 'other',
				},
			],
		}
	},
	head(this: any) {
		return {
			title: `${this.$t('titles.registration')} | WithIn`,
		}
	},
	mounted() {
		this.updateSalutation()
		this.getCountries()
	},
	methods: {
		getStepContainerHeight() {
			switch (this.step) {
				case 1:
					return '100px'

				case 9:
				case 14:
					return 'auto'

				default:
					return '200px'
			}
		},
		registerUser() {
			this.isSaving = true

			const affiliateId = localStorage.getItem('affiliate_id') || null

			this.$axios.post('/api/user/register', {
				email: this.user.email,
				first_name: this.user.firstName,
				last_name: this.user.lastName,
				password: this.user.password,
				primary_language: this.user.primaryLanguage,
				gender: this.user.gender,
				// eslint-disable-next-line max-len
				date_of_birth: `${this.user.dateOfBirth.year}-${this.user.dateOfBirth.month}-${this.user.dateOfBirth.day}`,
				country_of_residence: this.user.country,
				affiliate_id: affiliateId,
			}).then((resp) => {
				if (resp.data.status === 'ok') {
					this.$auth.setUserToken(resp.data.user.access_token, resp.data.user.refresh_token)
					this.$auth.setUser({
						id: resp.data.user.id,
						first_name: resp.data.user.first_name,
						last_name: resp.data.user.last_name,
					})
					this.step += 1

					// try {
					// 	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// 	// @ts-ignore
					// 	this.$gtag('event', 'conversion', {
					// 		send_to: 'AW-482552220/6UapCP2e1uoBEJzTjOYB',
					// 	});
					// } catch (err) {
					// 	console.log(err);
					// }
				} else if (resp.data.status === 'invalid_value') {
					this.toastMessage = `Ungültige Eingabe: ${resp.data.key}`
					this.showToast = true
				} else if (resp.data.status === 'email_already_registered') {
					this.toastMessage = 'Es existiert bereits ein Account mit dieser E-Mail-Adresse.'
					this.showToast = true
				} else {
					this.toastMessage = this.$t('error.unkown').toString()
					this.showToast = true
				}
			}).catch((err) => {
				console.log(err)
				this.toastMessage = this.$t('error.unkown').toString()
				this.showToast = true
			}).finally(() => {
				this.isSaving = false
				if (this.$auth.loggedIn && localStorage.getItem('registration_invitation_token')) {
					this.$axios.post('/api/chat/accept-invitation/', {
						token: localStorage.getItem('registration_invitation_token'),
					})
				}
			})
		},
		validPasswords() {
			return this.user.password.length >= 8
				&& this.user.password === this.user.passwordRepeat
				&& this.user.password.match(/.*[a-z].*/)
				&& this.user.password.match(/.*[A-Z].*/)
				&& this.user.password.match(/.*[0-9].*/)
		},
		stepCompleted(step: number) {
			switch (step) {
				case 2:
					return this.user.firstName.length > 1 && this.user.lastName.length > 1

				case 3:
					return this.user.dateOfBirth.day.length
						&& this.user.dateOfBirth.month.length
						&& this.user.dateOfBirth.year.length
						&& this.dateOfBirthValid()

				case 4:
					return this.user.country.length

				case 5:
					// eslint-disable-next-line no-case-declarations, max-len
					const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					return this.user.email.length >= 7 && re.test(String(this.user.email).toLowerCase())

				case 6:
					return this.privacyAccepted && this.termsAccepted

				case 9:
					return this.tmpImage

				case 10:
					return this.user.website.length > 0 || this.user.linkedIn.length > 0 || this.user.xing.length > 0

				case 11:
					return this.user.occupation.length > 0 || this.user.company.length > 0

				default:
					return true
			}
		},
		dateOfBirthValid(skipAgeCheck = false) {
			const day = Number(this.user.dateOfBirth.day)
			const month = Number(this.user.dateOfBirth.month)
			const year = Number(this.user.dateOfBirth.year)

			if (this.user.dateOfBirth.year.length < 4) {
				return false
			}

			const numericValues = !Number.isNaN(day) && !Number.isNaN(month) && !Number.isNaN(year)

			if (!numericValues || day === 0 || month === 0 || year === 0) {
				return false
			}

			// eslint-disable-next-line max-len
			const dateOfBirth = moment(`${this.user.dateOfBirth.year}-${this.user.dateOfBirth.month}-${this.user.dateOfBirth.day}`)
			const validDate = dateOfBirth.isValid()

			if (skipAgeCheck) {
				return validDate
			}

			const oldEnough = validDate && dateOfBirth.isBefore(moment().subtract(16, 'years'))

			this.user.dateOfBirth.tooYoung = validDate && !oldEnough

			return oldEnough
		},
		checkEmail() {
			if (this.isSaving) {
				return
			}

			this.isSaving = true
			this.emailRegistered = false

			this.$axios.get('/api/user/email-registered', {
				params: {
					email: this.user.email,
				},
			}).then((resp) => {
				if (resp.data.email_registered) {
					this.emailRegistered = true
				} else {
					this.step += 1
				}
			}).finally(() => {
				this.isSaving = false
			})
		},
		setImage(e: any) {
			const file = e.target.files[0]
			if (!file.type.includes('image/')) {
				this.$nuxt.$emit('showToastMessage', {
					message: 'Please select an image file.',
					duration: 3000,
				})
				return
			}
			if (typeof FileReader === 'function') {
				const reader = new FileReader()
				reader.onload = (event: any) => {
					this.dragging = false
					this.imageSelected = true
					this.tmpImage = event.target.result;
					// rebuild cropperjs with the updated source
					(<any> this.$refs.cropper).replace(event.target.result)
				}
				reader.readAsDataURL(file)
			} else {
				// eslint-disable-next-line no-alert
				alert('Sorry, FileReader API not supported')
			}
		},
		cropImage() {
			// get image data for post processing, e.g. upload or setting image src
			return (this.$refs.cropper as any).getCroppedCanvas({ width: 512 }).toDataURL()
		},
		updateImage() {
			this.isSaving = true
			this.$axios.post('/api/user/details/picture/base64', {
				profile_picture: this.cropImage(),
			}).then((resp) => {
				// this.userDetails.profile_picture_large = resp.data.url + '#' + Math.random()
				this.tmpImage = resp.data.url
				this.isSaving = false
				this.step += 1
				this.imageSelected = false
			}).catch(() => {
				this.showToast = true
				this.toastMessage = 'Beim Hochladen des Bildes ist ein Fehler aufgetreten.'
			}).finally(() => {
				this.isSaving = false
			})
		},
		updateProfile(toPortfolio = false) {
			this.isSaving = true
			/* TODO: validate linkedin/xing url clientside too */
			this.$axios.post('/api/user/details', {
				occupation: this.user.occupation,
				company: this.user.company,
				website: this.user.website,
				linkedin_url: this.user.linkedIn,
				xing_url: this.user.xing,
				public_profile: this.user.privacy.publicProfile,
				public_email: this.user.privacy.publicEmail,
			}).then(() => {
				this.isSaving = false
				this.$auth.fetchUser()
				if (toPortfolio) {
					this.$router.push('/portfolio')
				} else {
					this.step += 2
				}
			})
		},
		updateStepLabels() {
			this.steps = [
				{
					firstStep: 1,
					lastStep: 1,
					label: this.$t('onboarding.steps.language'),
				},
				{
					firstStep: 2,
					lastStep: 2,
					label: this.$t('onboarding.steps.name'),
				},
				{
					firstStep: 3,
					lastStep: 4,
					label: this.$t('onboarding.steps.personalDetails'),
				},
				{
					firstStep: 5,
					lastStep: 7,
					label: this.$t('onboarding.steps.credentials'),
				},
				{
					firstStep: 9,
					lastStep: 12,
					label: this.$t('onboarding.steps.profile'),
				},
				{
					firstStep: 13,
					lastStep: 13,
					label: this.$t('onboarding.steps.portfolio'),
				},
			]
		},
		updateSalutation() {
			const hour = parseInt(moment().format('H'), 10)

			if (hour > 17) {
				this.salutation = this.$t('salutation.evening').toString()
			} else if (hour > 11) {
				this.salutation = this.$t('salutation.day').toString()
			} else if (hour > 4) {
				this.salutation = this.$t('salutation.morning').toString()
			} else {
				this.salutation = this.$t('salutation.evening').toString()
			}
		},
		searchForCompanies() {
			this.$axios.get('/api/search/stocks', {
				params: {
					query: this.companySearchQuery,
				},
			}).then((response) => {
				if (response.data.results) {
					this.stockSearchResults = response.data.results
				} else {
					this.stockSearchResults = []
				}
			})
		},
		addToPortfolio(selection: any) {
			const securityName = selection.security_name
			const companyId = selection.company.id

			let alreadyInPortfolio = false

			this.shares.forEach((shares, index) => {
				if (
					shares.security_name === securityName
					&& shares.company.id === companyId
				) {
					if (shares.amount === 0) {
						this.shares.splice(index, 1)
					} else {
						alreadyInPortfolio = true
					}
				}
			})

			if (!alreadyInPortfolio) {
				this.shares.unshift({
					security_name: securityName,
					company: selection.company,
					amount: 1,
				})

				this.stockSearchResults = []
				this.companySearchQuery = ''
			}
		},
		removeFromPortfolio(index: number) {
			this.shares.splice(index, 1)
		},
		savePortfolio() {
			this.isSaving = true

			this.$axios.post('/api/user/portfolio', {
				shares: this.shares,
			}).then((resp) => {
				if (resp.data.status === 'ok') {
					this.step += 1
				}
			}).catch((err) => {
				console.log(err)
				// this.toastMessage = 'Beim Aktualisieren Ihres Portfolios ist ein Fehler aufgetreten.
				// Bitte versuchen Sie es später erneut.'
				// this.showToast = true
				// setTimeout(() => {
				// 	this.showToast = false
				// }, 2500)
			})
		},
		getCountries() {
			this.$axios.get('/api/available-countries', {
				params: {
					language: this.$i18n.locale,
				},
			}).then((resp) => {
				this.availableCountries = []

				resp.data.forEach((country: any) => {
					this.availableCountries.push({
						name: country.name ? country.name : country.country_code,
						code: country.country_code,
					})
				})
			})
		},
	},
})
